import { render } from "./LocalTimeDisplay.vue?vue&type=template&id=0c4454d8"
import script from "./LocalTimeDisplay.vue?vue&type=script&lang=js"
export * from "./LocalTimeDisplay.vue?vue&type=script&lang=js"

import "./LocalTimeDisplay.vue?vue&type=style&index=0&id=0c4454d8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__